module.exports = __webpack_public_path__ + "img/refund-2-line.9097ade9.svg";